<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-container pa-0>
          <v-row no-gutters class="test">
            <v-col>
              <no-autocomplete-textfield
                :disabled="disabled===true"
                :class="$attrs['class']"
                v-model="internalValue"
                :label="label"
                :rules="rules"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col style="margin-top:20px;margin-left:3px" cols="auto">
              <v-icon v-bind="attrs" v-on="on">help</v-icon>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
export default {
  inheritAttrs: false,
  name: "tooltip-textbox",
  props: ["value", "rules", "label", "tooltipText", "dialog", "disabled"],
  components:{
    NoAutocompleteTextfield
  },
  mounted() {
    // console.log(this.value);
    this.internalValue = this.value;
  },
  data() {
    return {
      internalValue: null,
      show: false,
      class: "",
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
  },
  watch: {
    value: {
      handler(v) {
        // console.log(v);
        this.internalValue = v;
      },
    },
    internalValue: {
      handler(v) {
        // console.log(v);
        this.$emit("update:value", v);
      },
    },
  },
  methods: {},
};
</script>
